module.exports = __webpack_public_path__ + "img/edit-profile.33729c45.svg";